/* UserList.js — کاربران و سطوح دسترسی */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { TabBar } from '../TabManager';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import useColumnResize from '../../hooks/useColumnResize';
import useTablePagination from '../../hooks/useTablePagination';

const toFa   = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);
const API    = (path,opts={}) => fetch(`/api/system${path}`,{
  headers:{'Content-Type':'application/json',Authorization:`Bearer ${localStorage.getItem('access')}`},...opts,
}).then(async r=>{
  // پاسخ غیر JSON (خطای سرور یا شبکه) هم باید به کاربر نشان داده شود، نه اینکه دکمه بی‌صدا بماند
  try { return await r.json(); }
  catch { return {ok:false, error:`پاسخ نامعتبر از سرور (کد ${r.status})`}; }
}).catch(()=>({ok:false, error:'ارتباط با سرور برقرار نشد'}));

const FInput = ({label,name,value,onChange,readOnly,flex=1,type='text',dir}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <input name={name} type={type} value={value??''} onChange={onChange} readOnly={readOnly}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',
        direction:dir||'rtl',textAlign:dir==='ltr'?'left':'right',
        width:'100%',boxSizing:'border-box',background:readOnly?'#f5f5f5':'#fff'}}/>
  </div>
);

const FSelect = ({label,name,value,onChange,options,flex=1}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <select name={name} value={value??''} onChange={onChange}
      style={{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',
        fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',
        width:'100%',boxSizing:'border-box',background:'#fff'}}>
      {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

const FDate = ({label,value,onChange,flex=1}) => (
  <div style={{display:'flex',flexDirection:'column',gap:'4px',flex}}>
    <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>{label}</label>
    <JalaliDatePicker value={value} onChange={onChange} placeholder={label}/>
  </div>
);

const FCheck = ({label,checked,onChange,color}) => (
  <label style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px',fontWeight:'700',
    color:color||'#444',cursor:'pointer'}}>
    <input type="checkbox" checked={!!checked} onChange={onChange}/><span>{label}</span>
  </label>
);

const KINDS = [
  {val:'all',   label:'همه'},
  {val:'user',  label:'کاربران'},
  {val:'group', label:'گروه‌های دسترسی'},
];

/* فیلترهای گرید دسترسی */
const PERM_KINDS = [
  {val:'all',    label:'همه'},
  {val:'tab',    label:'صفحه‌ها'},
  {val:'form',   label:'فرم‌ها'},
  {val:'button', label:'کلیدها'},
  {val:'diff',   label:'تغییریافته'},
];

const INIT_WIDTHS = [45,90,220,160,150,130,110,110,110,110,100,100];

const EMPTY = {people_id:0,people_name:'',username:'',password:'',group_name:'',
  start_date:'',end_date:'',full_access:0,full_view:0,supervisor:0,
  user_group_code:0,user_group_list:'',account_list:'',group_availability:0,
  zihesab_password:''};

export default function UserList({ user, onBack }) {
  const [rows,setRows]         = useState([]);
  const [total,setTotal]       = useState(0);
  const [hasMore,setHasMore]   = useState(false);
  const [loading,setLoading]   = useState(false);
  const [selected,setSelected] = useState(null);
  const [kind,setKind]         = useState('all');
  const [ready,setReady]       = useState(false);
  const [meta,setMeta]         = useState({user_groups:[],accounts:[],perm_groups:[],
    availability:[],today:''});

  const [modal,setModal]   = useState(null);   // new | edit | delete | perms | requests
  const [form,setForm]     = useState(EMPTY);
  const [error,setError]   = useState('');
  const [toast,setToast]   = useState('');
  const [lookup,setLookup] = useState([]);

  /* ── ماتریس دسترسی ── */
  const [perms,setPerms]       = useState([]);
  const [permInfo,setPermInfo] = useState({groups:[],access_level:0,access_title:''});
  const [permKind,setPermKind] = useState('all');
  const [permSearch,setPermSearch] = useState('');
  const [showAllowed,setShowAllowed]     = useState(true);
  const [showAvailable,setShowAvailable] = useState(true);
  const [showRequest,setShowRequest]     = useState(true);
  const [myGroups,setMyGroups] = useState([]);
  const [permLoading,setPermLoading] = useState(false);
  const [copySource,setCopySource]   = useState(0);

  /* ── درخواست‌های مجوز ── */
  const [requests,setRequests] = useState([]);

  const offsetRef = useRef(0);
  const {TH} = useColumnResize(INIT_WIDTHS);
  const {visibleRows,search,setSearch,totalCount,LoadMoreButton} = useTablePagination({
    allRows:rows, searchFields:['username','people_name','group_name'],
    serverTotal:total, serverHasMore:hasMore,
  });

  const showToast = m => { setToast(m); setTimeout(()=>setToast(''),2800); };

  // دکمه‌های باز برای کاربر جاری؛ تا جواب نیامده همه بسته‌اند
  const [sp,setSp] = useState({});
  useEffect(()=>{ (async()=>{
    try{ const d = await API('/menu-permissions/'); if(d.ok) setSp(d); }
    catch(e){ console.error(e); }
  })(); },[]);

  useEffect(()=>{ (async()=>{
    try{ const d = await API('/users/init/'); if(d.ok) setMeta(d); }
    catch(e){console.error(e);}
    setReady(true);
  })(); },[]);

  const fetchData = useCallback(async(reset=false)=>{
    if(reset){ offsetRef.current=0; setRows([]); setSelected(null); }
    setLoading(true);
    try{
      const off = reset?0:offsetRef.current;
      const d = await API(`/users/?offset=${off}&kind=${kind}`);
      if(d.ok){
        setRows(p=>reset?d.rows:[...p,...d.rows]);
        setTotal(d.total); setHasMore(d.has_more);
        offsetRef.current=(reset?0:offsetRef.current)+d.rows.length;
      } else if(d.error) showToast('⚠️ '+d.error);
    }catch(e){console.error(e);}
    setLoading(false);
  },[kind]);

  useEffect(()=>{ if(ready) fetchData(true); },[ready,kind]); // eslint-disable-line

  const handleChange = e => { const{name,value}=e.target; setForm(p=>({...p,[name]:value})); };

  const openNew  = ()=>{ setForm(EMPTY); setError(''); setLookup([]); setModal('new'); };
  const openEdit = ()=>{
    if(!selected) return;
    setForm({...EMPTY, ...selected, password:'', zihesab_password:''});
    setError(''); setLookup([]); setModal('edit');
  };

  /* اعتبارسنجی: یا کاربر یا گروه، نه هر دو */
  const validate = f => {
    const hasPeople = Number(f.people_id||0) > 0;
    const hasGroup  = String(f.group_name||'').trim().length > 0;
    if((!hasPeople && !hasGroup) || (hasPeople && hasGroup))
      return 'حتما فقط یکی از موارد زیر را تعیین کنید\nنام کاربر\nعنوان گروه دسترسی';
    return null;
  };

  const levelChanged = () => {
    if(modal==='new') return !!(form.full_access||form.full_view);
    return Number(form.full_access||0)!==Number(selected?.full_access||0)
        || Number(form.full_view||0)!==Number(selected?.full_view||0);
  };

  const handleSave = async()=>{
    const v = validate(form);
    if(v){ setError(v); return; }
    if(levelChanged() && !String(form.zihesab_password||'').trim()){
      setError('برای تغییر سطح دسترسی رمز ذیحساب لازم است'); return;
    }
    setError('');
    const url = modal==='new' ? '/users/create/' : `/users/${selected.id}/update/`;
    const d = await API(url,{method:'POST',body:JSON.stringify(form)});
    if(d.ok){ setModal(null); fetchData(true); showToast(modal==='new'?'✅ ثبت شد':'✅ ویرایش شد'); }
    else setError(d.error||'خطا');
  };

  const openDelete = ()=>{ if(!selected) return; setError(''); setModal('delete'); };
  const handleDelete = async()=>{
    const d = await API(`/users/${selected.id}/delete/`,{method:'POST'});
    if(d.ok){ setModal(null); setSelected(null); fetchData(true); showToast('✅ حذف شد'); }
    else setError(d.error||'خطا');
  };

  const doLookup = async q => {
    const d = await API(`/people/lookup/?q=${encodeURIComponent(q||'')}`);
    if(d.ok) setLookup(d.rows);
  };

  /* ── ماتریس دسترسی ── */
  const openPerms = async()=>{
    if(!selected) return;
    setPermLoading(true); setModal('perms'); setError('');
    const d = await API(`/users/${selected.id}/permissions/`);
    if(d.ok){
      setPerms(d.rows);
      setPermInfo({groups:d.groups,access_level:d.access_level,access_title:d.access_title});
      setMyGroups(d.groups.map(g=>g.group_user_id));
    } else { setPerms([]); setError(d.error||'خطا'); }
    setPermLoading(false);
  };

  const toggleRow = idx => setPerms(p=>p.map((r,n)=>
    n===idx ? {...r, selection: r.selection===1?0:1} : r));

  const bulkSet = value => {
    const visible = new Set(filteredPerms.map(r=>r._idx));
    setPerms(p=>p.map((r,n)=> visible.has(n) ? {...r, selection:value} : r));
  };

  const savePerms = async()=>{
    const d = await API(`/users/${selected.id}/permissions/save/`,{method:'POST',
      body:JSON.stringify({
        items: perms.filter(r=>r.selection>0).map(r=>({
          form_name:r.form_name, tab_name:r.tab_name,
          control_name:r.control_name, selection:r.selection })),
        groups: myGroups,
      })});
    if(d.ok){ showToast(`✅ ${toFa(d.count)} مجوز ثبت شد`); setModal(null); fetchData(true); }
    else setError(d.error||'خطا');
  };

  const copyPerms = async()=>{
    if(!copySource) return;
    if(!window.confirm('همه مجوزهای فعلی این کاربر پاک و با مجوزهای مبدأ جایگزین می‌شود. ادامه؟')) return;
    const d = await API(`/users/${selected.id}/permissions/copy/`,{method:'POST',
      body:JSON.stringify({source_user_id:copySource})});
    if(d.ok){ showToast(`✅ ${toFa(d.count)} مجوز کپی شد`); openPerms(); fetchData(true); }
    else setError(d.error||'خطا');
  };

  /* ── درخواست‌های مجوز ── */
  const openRequests = async()=>{
    const d = await API('/permission-requests/');
    if(d.ok){ setRequests(d.rows); setModal('requests'); }
    else alert(d.error||'خطا');
  };
  const decide = async(id,approve)=>{
    const d = await API(`/permission-requests/${id}/decide/`,{method:'POST',
      body:JSON.stringify({approve})});
    if(d.ok){
      const l = await API('/permission-requests/');
      if(l.ok) setRequests(l.rows);
      fetchData(true);
      showToast(approve?'✅ تأیید شد':'✅ رد شد');
    } else alert(d.error||'خطا');
  };

  /* فیلتر ماتریس */
  const filteredPerms = perms.map((r,idx)=>({...r,_idx:idx})).filter(r=>{
    if(r.selection===1 && !showAllowed)   return false;
    if(r.selection===2 && !showRequest)   return false;
    if(r.selection===0 && !showAvailable) return false;
    if(permKind==='tab'    && r.kind!=='tab')    return false;
    if(permKind==='form'   && r.kind!=='form')   return false;
    if(permKind==='button' && r.kind!=='button') return false;
    if(permKind==='diff'   && !r.inherited)      return false;
    if(permSearch){
      const q = permSearch.trim();
      const hay = [r.tab_text,r.form_text,r.control_text,r.tab_name,r.form_name,r.control_name]
        .join(' ');
      if(!hay.includes(q)) return false;
    }
    return true;
  });

  const kindOpts = meta.user_groups.map(g=>({value:g.code,label:g.title}));
  const isSelf = selected && Number(selected.id)===Number(user?.arjan_user_id);

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.hLeft}>
          <button onClick={onBack} style={s.backBtn}>← بازگشت</button>
          <div style={s.hLogo}><img src={require('../../assets/images/arjan.png')} alt="" style={{width:'34px',height:'34px',borderRadius:'7px'}}/></div>
          <div><div style={s.hTitle}>کاربران و سطوح دسترسی</div><div style={s.hSub}>بخش سیستم</div></div>
        </div>
        <span style={s.userName}>{user?.full_name}</span>
      </header>
      <TabBar/>

      <main style={s.main}>
        <div style={s.toolbar}>
          <div style={s.toolBtns}>
            {sp.users_new && <button onClick={openNew} style={s.btnNew}>＋ جدید</button>}
            {sp.users_edit && <button onClick={openEdit} disabled={!selected} style={{...s.btnEdit,opacity:selected?1:.4}}>✎ ویرایش</button>}
            {sp.users_delete && <button onClick={openDelete} disabled={!selected} style={{...s.btnDel,opacity:selected?1:.4}}>✕ حذف</button>}
            {sp.users_permission && <button onClick={openPerms} disabled={!selected} style={{...s.btnPerm,opacity:selected?1:.4}}>
              🔐 سطوح دسترسی{selected?` (${toFa(selected.perm_count)})`:''}</button>}
            {sp.users_permission && <button onClick={openRequests} style={s.btnReq}>📩 درخواست‌های مجوز</button>}
          </div>
        </div>

        <div style={s.toolbar2}>
          <div style={{display:'flex',gap:'12px',alignItems:'center',paddingBottom:'2px'}}>
            {KINDS.map(m=>(
              <label key={m.val} style={s.radio}>
                <input type="radio" name="kind" checked={kind===m.val} onChange={()=>setKind(m.val)}/>
                <span>{m.label}</span></label>))}
          </div>
          <div style={{marginRight:'auto'}}>
            <div style={s.fL}>جستجو</div>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="نام کاربری / نام شخص / گروه" style={{...s.fI,width:'280px'}}/>
          </div>
        </div>

        <div style={s.tableWrap}>
          <table style={{width:'100%',borderCollapse:'collapse',tableLayout:'fixed'}}>
            <thead style={{position:'sticky',top:0,zIndex:3}}>
              <tr>
                <TH idx={0}>ردیف</TH>
                <TH idx={1}>نوع</TH>
                <TH idx={2} right>نام کاربر</TH>
                <TH idx={3}>نام کاربری</TH>
                <TH idx={4} right>گروه دسترسی</TH>
                <TH idx={5}>سطح</TH>
                <TH idx={6} right>گروه کاربری</TH>
                <TH idx={7}>شروع اعتبار</TH>
                <TH idx={8}>خاتمه اعتبار</TH>
                <TH idx={9} gold>تعداد مجوز</TH>
                <TH idx={10} red>درخواستی</TH>
                <TH idx={11}>عضو گروه</TH>
              </tr>
            </thead>
            <tbody>
              {visibleRows.length===0 && (
                <tr><td colSpan={12} style={s.empty}>
                  {loading?'در حال بارگذاری...':'اطلاعاتی برای نمایش وجود ندارد'}</td></tr>)}
              {visibleRows.map((r,idx)=>{
                const sel = selected?.id===r.id;
                const bg = sel ? '#64b5f6'
                         : r.is_group ? '#ede7f6'
                         : r.expired ? '#ffebee'
                         : idx%2===0 ? '#fff' : '#fdf6e3';
                return (
                  <tr key={r.id} onClick={()=>setSelected(r)} style={{cursor:'pointer',background:bg}}
                    onMouseEnter={e=>{if(!sel)e.currentTarget.style.background='#bbdefb';}}
                    onMouseLeave={e=>{if(!sel)e.currentTarget.style.background=bg;}}>
                    <td style={s.td}>{toFa(idx+1)}</td>
                    <td style={s.td}>{r.is_group
                      ? <span style={{color:'#4a148c',fontWeight:'700'}}>گروه</span>
                      : <span style={{color:'#1b5e20'}}>کاربر</span>}</td>
                    <td style={{...s.td,textAlign:'right'}} title={r.people_name}>{r.people_name}</td>
                    <td style={{...s.td,direction:'ltr'}}>{r.username}</td>
                    <td style={{...s.td,textAlign:'right'}}>{r.group_name}</td>
                    <td style={s.td}>{r.full_access
                      ? <span style={{color:'#b71c1c',fontWeight:'700'}}>دسترسی کامل</span>
                      : r.full_view
                      ? <span style={{color:'#e65100',fontWeight:'700'}}>فقط مشاهده</span>
                      : <span style={{color:'#666'}}>عادی</span>}</td>
                    <td style={{...s.td,textAlign:'right'}}>{r.user_group}</td>
                    <td style={{...s.td,direction:'ltr'}}>{toFa(r.start_date)}</td>
                    <td style={{...s.td,direction:'ltr',
                      color:r.expired?'#c62828':'inherit',fontWeight:r.expired?'700':'400'}}>
                      {toFa(r.end_date)}</td>
                    <td style={{...s.td,fontWeight:'700',color:'#1565c0'}}>{toFa(r.perm_count)}</td>
                    <td style={{...s.td,color:r.pending_count?'#e65100':'#ccc',fontWeight:'700'}}>
                      {r.pending_count?toFa(r.pending_count):''}</td>
                    <td style={s.td}>{r.group_count?toFa(r.group_count):''}</td>
                  </tr>);
              })}
            </tbody>
          </table>
        </div>
        <LoadMoreButton onClick={()=>fetchData(false)} loading={loading}/>

        <div style={s.summary}>
          <span>تعداد: <b>{toFa(visibleRows.length)}</b> از <b>{toFa(totalCount)}</b></span>
          {selected && <>
            <span>انتخابی: <b>{selected.people_name||selected.group_name}</b></span>
            <span>مجوزها: <b style={{color:'#1565c0'}}>{toFa(selected.perm_count)}</b></span>
            {selected.pending_count>0 &&
              <span>درخواستی: <b style={{color:'#e65100'}}>{toFa(selected.pending_count)}</b></span>}
            {isSelf && <span style={{color:'#c62828',fontWeight:'700'}}>
              ⚠️ این حساب خود شماست — تغییر مجوزهایش مجاز نیست</span>}
          </>}
        </div>
      </main>

      {/* ══ مودال کاربر ══ */}
      {(modal==='new'||modal==='edit') && (
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'860px'}} onClick={e=>e.stopPropagation()}>
            <div style={s.mHeader}>
              <div style={s.mTitle}>{modal==='new'?'➕ ثبت کاربر یا گروه جدید':'✎ ویرایش'}</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={s.mBody}>
              {error&&<div style={{...s.errBox,whiteSpace:'pre-line'}}>{error}</div>}
              <div style={s.infoBox}>
                هر رکورد <b>یا</b> یک کاربر است (نام شخص را انتخاب کنید)
                <b> یا</b> یک گروه دسترسی (عنوان گروه را بنویسید). هرگز هر دو با هم.
              </div>
              <div style={s.row}>
                <div style={{flex:'0 0 48%',display:'flex',flexDirection:'column',gap:'4px',position:'relative'}}>
                  <label style={{fontSize:'12px',fontWeight:'600',color:'#555'}}>نام کاربر (شخص)</label>
                  <input value={form.people_name} placeholder="کد ملی یا نام شخص..."
                    onChange={e=>{setForm(p=>({...p,people_name:e.target.value,people_id:0}));doLookup(e.target.value);}}
                    onFocus={()=>doLookup(form.people_name)} style={s.fI}/>
                  {lookup.length>0&&(
                    <div style={s.dropdown}>{lookup.map(r=>(
                      <div key={r.id} onClick={()=>{setForm(p=>({...p,people_id:r.id,people_name:r.title}));setLookup([]);}}
                        style={s.dropItem}>{r.title}</div>))}</div>)}
                </div>
                <FInput label="عنوان گروه دسترسی" name="group_name" value={form.group_name}
                  onChange={handleChange} flex="0 0 48%"/>
              </div>
              <div style={s.row}>
                <FInput label="نام کاربری" name="username" value={form.username}
                  onChange={handleChange} dir="ltr" flex="0 0 32%"/>
                <FInput label={modal==='new'?'رمز عبور':'رمز جدید (خالی = بدون تغییر)'}
                  name="password" value={form.password} onChange={handleChange}
                  type="password" dir="ltr" flex="0 0 32%"/>
              </div>
              <div style={s.row}>
                <FDate label="شروع اعتبار" value={form.start_date}
                  onChange={v=>setForm(p=>({...p,start_date:v}))} flex="0 0 32%"/>
                <FDate label="خاتمه اعتبار" value={form.end_date}
                  onChange={v=>setForm(p=>({...p,end_date:v}))} flex="0 0 32%"/>
              </div>
              <div style={{...s.row,alignItems:'center',gap:'24px'}}>
                <FCheck label="دسترسی کامل (FullAccess)" color="#b71c1c"
                  checked={Number(form.full_access)===1}
                  onChange={e=>setForm(p=>({...p,full_access:e.target.checked?1:0,
                    full_view:e.target.checked?0:p.full_view}))}/>
                <FCheck label="فقط مشاهده (FullView)" color="#e65100"
                  checked={Number(form.full_view)===1}
                  onChange={e=>setForm(p=>({...p,full_view:e.target.checked?1:0,
                    full_access:e.target.checked?0:p.full_access}))}/>
                <FCheck label="ناظر قرارداد"
                  checked={Number(form.supervisor)===1}
                  onChange={e=>setForm(p=>({...p,supervisor:e.target.checked?1:0}))}/>
              </div>
              {levelChanged() && (
                <div style={s.row}>
                  <div style={{flex:1}}>
                    <div style={s.warnBox}>
                      ⚠️ تغییر سطح دسترسی نیازمند تأیید با رمز ذیحساب است.
                    </div>
                    <FInput label="رمز ذیحساب" name="zihesab_password"
                      value={form.zihesab_password} onChange={handleChange}
                      type="password" dir="ltr"/>
                  </div>
                </div>)}
              <div style={s.row}>
                <FSelect label="گروه کاربری (واحد سازمانی)" name="user_group_code"
                  value={form.user_group_code}
                  onChange={e=>setForm(p=>({...p,user_group_code:Number(e.target.value)}))}
                  options={[{value:0,label:'—'},...kindOpts]} flex="0 0 48%"/>
                <FSelect label="دسترسی به اسناد هزینه" name="group_availability"
                  value={form.group_availability}
                  onChange={e=>setForm(p=>({...p,group_availability:Number(e.target.value)}))}
                  options={meta.availability.map(a=>({value:a.code,label:a.title}))}
                  flex="0 0 48%"/>
              </div>
              <div style={s.row}>
                <FInput label="گروه‌های کاربری مجاز (کد، جدا با کاما)" name="user_group_list"
                  value={form.user_group_list} onChange={handleChange} dir="ltr" flex="0 0 48%"/>
                <FInput label="حساب‌های مجاز (کد، جدا با کاما)" name="account_list"
                  value={form.account_list} onChange={handleChange} dir="ltr" flex="0 0 48%"/>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              <button onClick={handleSave} style={s.btnSave}>ثبت</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ مودال حذف ══ */}
      {modal==='delete'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'500px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>
              <div style={s.mTitle}>⚠️ تأیید حذف</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              <p style={{fontSize:'14px',lineHeight:'2'}}>
                آیا از حذف <b>{selected.people_name||selected.group_name}</b> مطمئن هستید؟</p>
              {selected.perm_count+selected.pending_count+selected.group_count>0 &&
                <p style={{color:'#c62828',fontWeight:'700'}}>
                  ⚠️ ابتدا مجوزهای کاربر را حذف کنید.</p>}
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>لغو</button>
              {selected.perm_count+selected.pending_count+selected.group_count===0 &&
                <button onClick={handleDelete}
                  style={{...s.btnSave,background:'linear-gradient(135deg,#b71c1c,#c62828)'}}>حذف</button>}
            </div>
          </div>
        </div>
      )}

      {/* ══ ماتریس سطوح دسترسی ══ */}
      {modal==='perms'&&selected&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'1180px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#1a237e,#283593)'}}>
              <div style={s.mTitle}>
                🔐 سطوح دسترسی — {selected.people_name||selected.group_name}
                {permInfo.access_level>0 && ` | ${permInfo.access_title}`}
              </div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button>
            </div>
            <div style={s.mBody}>
              {error&&<div style={s.errBox}>{error}</div>}
              {isSelf && <div style={s.warnBox}>
                ⚠️ این حساب خود شماست. تغییر مجوزهای حساب خودتان مجاز نیست.</div>}
              {permInfo.access_level===2 && <div style={s.warnBox}>
                این کاربر <b>دسترسی کامل</b> دارد و صرف‌نظر از تیک‌های زیر، به همه فرم‌ها و
                کلیدها دسترسی دارد. فقط ورود به «صفحه‌ها» همچنان مجوز صریح می‌خواهد.</div>}
              {permInfo.access_level===1 && <div style={s.warnBox}>
                این کاربر <b>فقط مشاهده</b> دارد: همه فرم‌ها را می‌بیند ولی کلیدهای
                تغییردهنده (جدید، ویرایش، حذف و مانند آن) برایش بسته است.</div>}

              {/* عضویت در گروه‌های دسترسی */}
              {meta.perm_groups.length>0 && (
                <div style={s.groupBox}>
                  <div style={{fontSize:'12px',fontWeight:'700',marginBottom:'8px',color:'#4a148c'}}>
                    عضویت در گروه‌های دسترسی — مجوزهای گروه به این کاربر ارث می‌رسد
                  </div>
                  <div style={{display:'flex',gap:'14px',flexWrap:'wrap'}}>
                    {meta.perm_groups.filter(g=>g.id!==selected.id).map(g=>(
                      <FCheck key={g.id} label={g.title} color="#4a148c"
                        checked={myGroups.includes(g.id)}
                        onChange={e=>setMyGroups(p=>e.target.checked
                          ? [...p,g.id] : p.filter(x=>x!==g.id))}/>))}
                  </div>
                </div>)}

              {/* فیلترها */}
              <div style={s.permBar}>
                <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
                  {PERM_KINDS.map(m=>(
                    <label key={m.val} style={s.radio}>
                      <input type="radio" name="pk" checked={permKind===m.val}
                        onChange={()=>setPermKind(m.val)}/><span>{m.label}</span></label>))}
                </div>
                <div style={{display:'flex',gap:'10px',flexWrap:'wrap'}}>
                  <FCheck label="مجاز" color="#1b5e20" checked={showAllowed}
                    onChange={e=>setShowAllowed(e.target.checked)}/>
                  <FCheck label="بدون مجوز" checked={showAvailable}
                    onChange={e=>setShowAvailable(e.target.checked)}/>
                  <FCheck label="درخواستی" color="#e65100" checked={showRequest}
                    onChange={e=>setShowRequest(e.target.checked)}/>
                </div>
                <input value={permSearch} onChange={e=>setPermSearch(e.target.value)}
                  placeholder="جستجو در نام صفحه / فرم / کلید"
                  style={{...s.fI,width:'240px',marginRight:'auto'}}/>
              </div>
              <div style={{display:'flex',gap:'8px',marginBottom:'8px',flexWrap:'wrap'}}>
                <button onClick={()=>bulkSet(1)} disabled={isSelf} style={s.btnMini}>
                  ✔ همه موارد نمایش‌داده‌شده مجاز</button>
                <button onClick={()=>bulkSet(0)} disabled={isSelf}
                  style={{...s.btnMini,background:'#ffcdd2',color:'#b71c1c',borderColor:'#ef9a9a'}}>
                  ✕ همه موارد نمایش‌داده‌شده بدون مجوز</button>
                <span style={{fontSize:'11px',color:'#888',alignSelf:'center'}}>
                  نمایش {toFa(filteredPerms.length)} از {toFa(perms.length)} |
                  {' '}مجاز: {toFa(perms.filter(r=>r.selection===1).length)}
                </span>
                <div style={{marginRight:'auto',display:'flex',gap:'6px',alignItems:'center'}}>
                  <select value={copySource} onChange={e=>setCopySource(Number(e.target.value))}
                    style={{...s.fI,width:'200px',padding:'6px 10px'}}>
                    <option value={0}>کپی مجوز از...</option>
                    {rows.filter(r=>r.id!==selected.id).map(r=>(
                      <option key={r.id} value={r.id}>{r.people_name||r.group_name}</option>))}
                  </select>
                  <button onClick={copyPerms} disabled={!copySource||isSelf}
                    style={{...s.btnMini,opacity:copySource&&!isSelf?1:.4}}>کپی</button>
                </div>
              </div>

              <div style={{overflow:'auto',maxHeight:'46vh'}}>
                <table style={{width:'100%',borderCollapse:'collapse'}}>
                  <thead><tr>
                    {['وضعیت','صفحه','فرم','کلید','نام فنی','ارث از گروه']
                      .map(h=><th key={h} style={s.subTh}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {permLoading&&<tr><td colSpan={6} style={s.empty}>در حال بارگذاری...</td></tr>}
                    {!permLoading&&filteredPerms.length===0&&
                      <tr><td colSpan={6} style={s.empty}>موردی مطابق فیلتر نیست</td></tr>}
                    {filteredPerms.map(r=>(
                      <tr key={r._idx} onClick={()=>!isSelf&&toggleRow(r._idx)}
                        style={{cursor:isSelf?'not-allowed':'pointer',
                          background:r.selection===1?'#e8f5e9'
                                    :r.selection===2?'#fff3e0'
                                    :r.inherited?'#ede7f6':'#fff'}}>
                        <td style={s.subTd}>
                          {r.selection===1?<span style={{color:'#1b5e20',fontWeight:'700'}}>✔ مجاز</span>
                           :r.selection===2?<span style={{color:'#e65100',fontWeight:'700'}}>⏳ درخواستی</span>
                           :<span style={{color:'#bbb'}}>—</span>}
                        </td>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.tab_text}</td>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.form_text}</td>
                        <td style={{...s.subTd,textAlign:'right'}}>
                          {r.control_text}
                          {r.always?<span style={{color:'#1565c0',fontSize:'10px'}}> (همیشه باز)</span>:''}
                          {r.mutating?<span style={{color:'#c62828',fontSize:'10px'}}> (تغییردهنده)</span>:''}
                        </td>
                        <td style={{...s.subTd,direction:'ltr',fontSize:'10px',color:'#888'}}>
                          {[r.tab_name,r.form_name,r.control_name].filter(Boolean).join('.')}</td>
                        <td style={s.subTd}>{r.inherited
                          ? <span style={{color:'#4a148c',fontWeight:'700'}}>✔</span> : ''}</td>
                      </tr>))}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>انصراف</button>
              <button onClick={savePerms} disabled={isSelf}
                style={{...s.btnSave,opacity:isSelf?.4:1}}>ثبت مجوزها</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ درخواست‌های مجوز ══ */}
      {modal==='requests'&&(
        <div style={s.overlay} onClick={()=>setModal(null)}>
          <div style={{...s.modal,maxWidth:'900px'}} onClick={e=>e.stopPropagation()}>
            <div style={{...s.mHeader,background:'linear-gradient(135deg,#e65100,#f57c00)'}}>
              <div style={s.mTitle}>📩 درخواست‌های مجوز در انتظار تأیید</div>
              <button onClick={()=>setModal(null)} style={s.closeBtn}>✕</button></div>
            <div style={s.mBody}>
              <div style={s.infoBox}>
                وقتی کاربری به فرمی دسترسی ندارد، برنامه به او پیشنهاد می‌دهد درخواست مجوز
                بفرستد. آن درخواست‌ها اینجا نمایش داده می‌شوند و تا تأیید نشوند اثری ندارند.
              </div>
              <div style={{overflow:'auto',maxHeight:'55vh'}}>
                <table style={{width:'100%',borderCollapse:'collapse'}}>
                  <thead><tr>
                    {['کاربر','نام کاربری','فرم','کلید','نام فنی','']
                      .map(h=><th key={h} style={s.subTh}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {requests.length===0&&<tr><td colSpan={6} style={s.empty}>
                      درخواستی در انتظار تأیید نیست</td></tr>}
                    {requests.map((r,idx)=>(
                      <tr key={r.id} style={{background:idx%2===0?'#fff':'#fff8e1'}}>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.people_name||r.group_name}</td>
                        <td style={{...s.subTd,direction:'ltr'}}>{r.username}</td>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.form_text||r.form_name}</td>
                        <td style={{...s.subTd,textAlign:'right'}}>{r.control_text}</td>
                        <td style={{...s.subTd,direction:'ltr',fontSize:'10px',color:'#888'}}>
                          {[r.form_name,r.control_name].filter(Boolean).join('.')}</td>
                        <td style={s.subTd}>
                          <button onClick={()=>decide(r.id,true)} style={s.btnMini}>تأیید</button>
                          <button onClick={()=>decide(r.id,false)}
                            style={{...s.btnMini,background:'#ffcdd2',color:'#b71c1c',
                              borderColor:'#ef9a9a',marginRight:'4px'}}>رد</button>
                        </td>
                      </tr>))}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={s.mFooter}>
              <button onClick={()=>setModal(null)} style={s.btnCancel}>بستن</button>
            </div>
          </div>
        </div>
      )}

      {toast&&<div style={s.toast}>{toast}</div>}
    </div>
  );
}

const s = {
  page:{height:'100vh',overflow:'hidden',background:'#f0f2f7',fontFamily:"'Vazirmatn',Tahoma,sans-serif",direction:'rtl',display:'flex',flexDirection:'column'},
  header:{background:'linear-gradient(135deg,#0a1628,#1a2f50)',padding:'10px 24px',display:'flex',justifyContent:'space-between',alignItems:'center',boxShadow:'0 2px 16px rgba(0,0,0,0.3)',flexShrink:0},
  hLeft:{display:'flex',alignItems:'center',gap:'12px'},
  backBtn:{padding:'6px 14px',background:'rgba(255,255,255,0.12)',color:'#fff',border:'1px solid rgba(255,255,255,0.25)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  hLogo:{width:'40px',height:'40px',background:'rgba(200,168,75,0.12)',border:'1px solid rgba(200,168,75,0.3)',borderRadius:'9px',display:'flex',alignItems:'center',justifyContent:'center'},
  hTitle:{fontSize:'15px',fontWeight:'700',color:'#fff'},
  hSub:{fontSize:'11px',color:'rgba(255,255,255,0.55)'},
  userName:{fontSize:'13px',color:'rgba(255,255,255,0.85)'},
  main:{padding:'8px 20px',flex:1,display:'flex',flexDirection:'column',overflow:'auto',minHeight:0},
  toolbar:{display:'flex',alignItems:'center',gap:'8px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolbar2:{display:'flex',alignItems:'flex-end',gap:'14px',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',marginBottom:'6px',flexWrap:'wrap',flexShrink:0},
  toolBtns:{display:'flex',gap:'7px',flexWrap:'wrap'},
  radio:{display:'flex',alignItems:'center',gap:'5px',fontSize:'12px',fontWeight:'600',color:'#444',cursor:'pointer'},
  fL:{fontSize:'11px',fontWeight:'600',color:'#555',marginBottom:'3px'},
  fI:{padding:'8px 12px',border:'1.5px solid #e0e0e0',borderRadius:'8px',fontSize:'13px',fontFamily:"'Vazirmatn',Tahoma,sans-serif",outline:'none',direction:'rtl',textAlign:'right',boxSizing:'border-box',width:'100%'},
  btnNew:{padding:'7px 16px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  btnEdit:{padding:'7px 16px',background:'linear-gradient(135deg,#1a237e,#283593)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnDel:{padding:'7px 16px',background:'linear-gradient(135deg,#b71c1c,#c62828)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnPerm:{padding:'7px 16px',background:'linear-gradient(135deg,#4a148c,#6a1b9a)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnReq:{padding:'7px 16px',background:'linear-gradient(135deg,#e65100,#f57c00)',color:'#fff',border:'none',borderRadius:'8px',fontFamily:'inherit',fontSize:'13px',fontWeight:'700',cursor:'pointer'},
  btnMini:{padding:'4px 10px',background:'#e8f5e9',color:'#1b5e20',border:'1px solid #a5d6a7',borderRadius:'6px',cursor:'pointer',fontFamily:'inherit',fontSize:'11px',fontWeight:'700'},
  tableWrap:{overflowX:'auto',overflowY:'auto',borderRadius:'10px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',background:'#fff',flex:1,minHeight:'260px'},
  td:{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},
  empty:{textAlign:'center',padding:'40px',color:'#999',fontSize:'13px'},
  summary:{display:'flex',gap:'18px',flexWrap:'wrap',background:'#fff',padding:'8px 14px',borderRadius:'10px',boxShadow:'0 1px 6px rgba(0,0,0,0.08)',margin:'6px 0',fontSize:'12px',color:'#444',flexShrink:0},
  subTh:{padding:'7px 9px',background:'#0d2137',color:'#C8A84B',fontSize:'11px',fontWeight:'700',whiteSpace:'nowrap',position:'sticky',top:0,zIndex:2},
  subTd:{padding:'6px 8px',borderBottom:'1px solid #f0f0f0',textAlign:'center',fontSize:'12px'},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.55)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'16px'},
  modal:{background:'#fff',borderRadius:'16px',width:'100%',maxWidth:'760px',maxHeight:'92vh',display:'flex',flexDirection:'column',boxShadow:'0 20px 60px rgba(0,0,0,0.4)'},
  mHeader:{display:'flex',justifyContent:'space-between',alignItems:'center',gap:'10px',padding:'14px 20px',background:'linear-gradient(135deg,#0a1628,#1a2f50)',borderRadius:'16px 16px 0 0'},
  mTitle:{fontSize:'14px',fontWeight:'700',color:'#fff'},
  closeBtn:{background:'rgba(255,255,255,0.15)',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',width:'30px',height:'30px',borderRadius:'50%',cursor:'pointer',fontSize:'13px',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0},
  mBody:{overflowY:'auto',flex:1,padding:'18px'},
  mFooter:{display:'flex',justifyContent:'flex-end',gap:'10px',padding:'12px 18px',borderTop:'1px solid #f0f2f7',background:'#f8f9fa',borderRadius:'0 0 16px 16px'},
  row:{display:'flex',gap:'12px',marginBottom:'12px',flexWrap:'wrap'},
  permBar:{display:'flex',gap:'16px',alignItems:'center',flexWrap:'wrap',background:'#fafafa',border:'1px solid #eee',borderRadius:'8px',padding:'10px 12px',marginBottom:'10px'},
  groupBox:{background:'#f3e5f5',border:'1px solid #ce93d8',borderRadius:'8px',padding:'10px 14px',marginBottom:'10px'},
  errBox:{background:'#fff3f3',border:'1px solid #ffcdd2',borderRadius:'8px',padding:'10px 14px',color:'#c62828',marginBottom:'10px',fontSize:'13px'},
  warnBox:{background:'#fff8e1',border:'1px solid #ffe082',borderRadius:'8px',padding:'9px 14px',color:'#e65100',marginBottom:'10px',fontSize:'12px',lineHeight:'1.9'},
  infoBox:{background:'#e3f2fd',border:'1px solid #90caf9',borderRadius:'8px',padding:'9px 14px',color:'#0d47a1',fontSize:'12px',lineHeight:'1.9',marginBottom:'12px'},
  dropdown:{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1px solid #ddd',borderRadius:'8px',maxHeight:'200px',overflowY:'auto',zIndex:50,boxShadow:'0 6px 20px rgba(0,0,0,0.18)'},
  dropItem:{padding:'7px 11px',fontSize:'12px',cursor:'pointer',borderBottom:'1px solid #f5f5f5',textAlign:'right'},
  btnCancel:{padding:'8px 18px',background:'#e0e0e0',color:'#333',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px'},
  btnSave:{padding:'8px 22px',background:'linear-gradient(135deg,#1b5e20,#2e7d32)',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontFamily:'inherit',fontSize:'13px',fontWeight:'700'},
  toast:{position:'fixed',bottom:'24px',right:'24px',background:'#1b5e20',color:'#fff',padding:'12px 24px',borderRadius:'10px',fontSize:'14px',fontWeight:'600',zIndex:2000,boxShadow:'0 4px 16px rgba(0,0,0,0.25)'},
};
